import { Middleware } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

import { dashboardSliceName, updateVotePage } from './dashboard';

// Each tab holds its own copy of the vote pages, so a change made in one (voting closed, a new theme)
// is replayed in the rest, a presenting stage included. Missing in jsdom and older Safari: tabs then stay apart.
const channel = typeof BroadcastChannel === 'undefined' ? null : new BroadcastChannel('izivote-vote-pages');
let replaying = false;

export const votePageSync: Middleware = (store) => {
  if (channel) {
    channel.onmessage = ({ data }: MessageEvent<ReturnType<typeof updateVotePage>['payload']>) => {
      // Only a page this tab already has, or one still loading would get a partial page in its place.
      if (!(store.getState() as RootState)[dashboardSliceName].votePages[data.votePageId]) return;

      replaying = true;
      try {
        store.dispatch(updateVotePage(data));
      } finally {
        replaying = false;
      }
    };
  }

  return (next) => (action) => {
    const result = next(action);
    if (channel && !replaying && updateVotePage.match(action)) channel.postMessage(action.payload);

    return result;
  };
};
